import {
  BranchDocuService,
  GetDocuRunningFormat,
} from "../model/backoffice/docubranch";
import { CustomerService } from "../model/customer";
import { FieldParams } from "./FieldObject";
import { DeepMergeObject, DotStringToObject } from "./Helper";
import {
  FieldDataType,
  FormControlType,
  getCommalessNumber,
  getDecimalString,
} from "./Helper2";

export const GetInvoiceHeaderObject = (props) => {
  const {
    docuList,
    customer,
    onSelectDocument,
    docuFieldIdName,
    head,
    custClick,
  } = props;
  const cancleClick = (item, setObject) => {
    if (!setObject) return;
    setObject((pv) => ({
      ...pv,
      ...DeepMergeObject(
        DotStringToObject(item.fieldName + "." + item.searchValueName, 0),
        DotStringToObject(item.fieldName + "." + item.searchDisplayName, null)
      ),
    }));
  };
  return {
    [docuFieldIdName]: {
      ...new FieldParams(
        docuFieldIdName,
        "DocuId",
        true,
        FieldDataType.NUMERIC,
        FormControlType.HIDDEN
      ),
    },

    BranchDocu: {
      ...new FieldParams(
        "DocuBranch",
        "ประเภทเอกสาร",
        true,
        FieldDataType.NUMERIC,
        FormControlType.SELECT
      ),
      selectData: docuList,
      selectHasFirstOption: false,
      selectBuildObjectPath: "DocuBranch.BranchDocu",
      selectValueName: "DocuBrchId",
      selectDisplayName: "DocuType.DocuTypeName",
      onChange: onSelectDocument,
      disabled: head?.[docuFieldIdName] ? true : false,
    },
    DocuNo: {
      ...new FieldParams(
        "DocuNo",
        "เลขที่เอกสาร",
        true,
        FieldDataType.TEXT,
        null,
        head?.DocuNo ?? null
      ),
      disabled: head?.[docuFieldIdName] ? true : false,
    },
    DocuDate: {
      ...new FieldParams(
        "DocuDate",
        "วันที่เอกสาร",
        true,
        FieldDataType.DATE,
        FormControlType.DATE_PICKER
      ),
      disabled: head?.[docuFieldIdName] ? true : false,
    },
    Customer: {
      ...new FieldParams(
        "Customer",
        "ตั้งเบิกกับ",
        true,
        FieldDataType.NUMERIC,
        FormControlType.SEARCHER
      ),
      tableColumnFieldName: "Customer.CustShortName",
      searchDisplayName: "CustShortName",
      searchValueName: "CustId",
      searchButtonClick: custClick,
      searchCancelClick: cancleClick,
    },
    BillTo: new FieldParams("BillTo", "ชื่อหน่วยงาน", null, null, null),
    Addr1: new FieldParams(
      "BillAddr1",
      "ที่อยู่",
      null,
      null,
      null,
      customer?.Addr ?? null
    ),
    Addr2: new FieldParams("BillAddr2", "", null, null, null),
    Phone: new FieldParams("BillPhone", "เบอร์โทร", null, null, null),
    CreditDays: {
      ...new FieldParams(
        "CreditDays",
        "เครดิต(วัน)",
        true,
        FieldDataType.NUMERIC,
        FormControlType.NUMERIC
      ),
      style: { maxWidth: "50px" },
    },
    DocuDueDate: new FieldParams(
      "DocuDueDate",
      "วันที่นัดชำระ",
      true,
      FieldDataType.DATE,
      FormControlType.DATE_PICKER
    ),
  };
};

export const GetInvoiceFooterObject = (props) => {
  const { onChangeDiscount, summary } = props;

  return {
    Amount: {
      ...new FieldParams(
        "Amount",
        "ยอดรวม",
        true,
        FieldDataType.NUMERIC,
        FormControlType.DECIMAL_LOCK_VALUE
      ),
      readOnly: true,
    },
    Discount: {
      ...new FieldParams(
        "Discount",
        "ส่วนลด",
        true,
        FieldDataType.NUMERIC,
        FormControlType.DECIMAL_LOCK_VALUE
      ),
    },
    Total: {
      ...new FieldParams(
        "Total",
        "รวม",
        true,
        FieldDataType.NUMERIC,
        FormControlType.DECIMAL_LOCK_VALUE
      ),
      readOnly: true,
    },
    VatRate: {
      ...new FieldParams(
        "VatRate",
        "อัตราภาษี",
        true,
        FieldDataType.NUMERIC,
        FormControlType.DECIMAL_LOCK_VALUE
      ),
      readOnly: true,
    },
    VatTotal: {
      ...new FieldParams(
        "VatTotal",
        "ยอดรวมภาษี",
        true,
        FieldDataType.NUMERIC,
        FormControlType.DECIMAL_LOCK_VALUE
      ),
      readOnly: true,
    },
    NetTotal: {
      ...new FieldParams(
        "NetTotal",
        "รวมทั้งสิ้น",
        true,
        FieldDataType.NUMERIC,
        FormControlType.DECIMAL_LOCK_VALUE
      ),
      readOnly: true,
    },
  };
};

/**
 * คำนวณ Vat นอก
 * @param {*} amount
 * @param {*} vatRate
 * @param {*} holdingTaxRate
 * @param {*} stateSum
 */
export const CalcSumVatExclude = (
  amount,
  vatRate,
  holdingTaxRate,
  stateSum
) => {
  const [sum, setSum] = stateSum;

  sum.Amount = getDecimalString(amount, 2);
  let total = getCommalessNumber(sum.Amount) - getCommalessNumber(sum.Discount);
  sum.Total = getDecimalString(total, 2);

  let vatTotal = total * getCommalessNumber(vatRate);
  let netTotal = Number(total) + Number(vatTotal);

  let holdingTaxAmount = netTotal * holdingTaxRate;
  sum.VatRate = getDecimalString(vatRate);
  sum.VatTotal = getDecimalString(vatTotal);
  sum.NetTotal = getDecimalString(netTotal);
  sum.HoldingTaxAmount = getDecimalString(holdingTaxAmount);

  setSum(sum);
};

/**
 * Vat ใน
 * @param {*} amount
 * @param {*} vatRate
 * @param {*} holdingTaxRate
 * @param {*} stateSum
 */
export const CalcSumVatInclude = (
  amount,
  vatRate,
  holdingTaxRate,
  stateSum
) => {
  const [sum, setSum] = stateSum;

  sum.Amount = getDecimalString(amount, 2);
  let total = getCommalessNumber(sum.Amount) - getCommalessNumber(sum.Discount);

  let vatTotal = total * ((vatRate * 100) / (100 + vatRate * 100));

  let netTotal = Number(amount) - vatTotal;

  sum.Total = getDecimalString(netTotal, 2);

  let holdingTaxAmount = netTotal * holdingTaxRate;
  sum.VatRate = getDecimalString(vatRate, 2);
  sum.VatTotal = getDecimalString(vatTotal, 2);
  sum.NetTotal = getDecimalString(total, 2);
  sum.HoldingTaxAmount = getDecimalString(holdingTaxAmount, 2);
  setSum(sum);
};

export const CalcSummary = ([
  runningDocu,
  sumItem,
  sumData,
  setSumData,
  editor,
]) => {
  let vatRate = Math.max(
    Number(sumData?.VatRate) || 0,
    Number(runningDocu?.BranchDocu?.DocuType?.VatRate) || 0
  );

  if (runningDocu?.BranchDocu?.DocuType?.VatInclude) {
    CalcSumVatInclude(
      sumItem([editor]),
      vatRate,
      getCommalessNumber(sumData?.HoldingTaxRate ?? 0),
      [sumData, setSumData]
    );
  } else {
    CalcSumVatExclude(
      sumItem([editor]),
      vatRate,
      getCommalessNumber(sumData?.HoldingTaxRate ?? 0),
      [sumData, setSumData]
    );
  }
};

export const LoadCustomer = async (custId, [userInfo, setData]) => {
  let cust = await CustomerService.GetItemNew({ custid: custId }, userInfo);
  setData((pv) => ({
    ...pv,
    ...{
      Customer: { CustId: cust?.CustId, CustShortName: cust?.CustShortName },
      BillTo: cust?.Prefix?.PrefixText + cust?.CustName,
      BillAddr1: cust?.Addr,
      BillAddr2: cust?.Addr2,
      BillPhone: cust?.CustPhone,
      CreditDays: cust?.CreditDays ?? 0,
    },
  }));
  return cust;
};

export const LoadDocuList = async ([userInfo, setDocuList], formtype) => {
  let docus = await BranchDocuService.GetList(
    {
      text: null,
      root: "brchid=" + userInfo.brchid + " and docu_direction=" + formtype,
    },
    userInfo
  );
  setDocuList(docus ?? []);
};

export const GetRunningDocu = async ([
  data,
  setData,
  userInfo,
  setRunningDocu,
]) => {
  let bDocu = await BranchDocuService.GetRunningNumber(
    {
      DocuBrchId: data?.DocuBranch?.BranchDocu?.DocuBrchId, // ส่งรหัสเอกสารสาขา
    },
    userInfo
  );

  let lastnum = GetDocuRunningFormat(bDocu);
  setData((pv) => {
    return { ...pv, ...{ DocuNo: lastnum } };
  });

  setRunningDocu(bDocu);
};
